import { inductionOrderApi } from "./inductionOrder";

export const { useCreatePepsiInductionOrderMutation } = inductionOrderApi;
